import {
  useLazyGetFrontDeskReferralMembers,
  useLazyGetPersonReferralMembers,
  useLazyGetReferralLeads,
  useLazyGetReferralMembers,
  useLazyGetReferralPTLeads,
  useLazyGetCampaignReferralMembers,
  useLazyGetPTCampaignReferralMembers,
} from 'api/referral.api';
import { PeakModules } from 'common/constants/peakModules';

type LazyTrigger<T> = (args: T) => any;

export type SearchReferralMembersReturn =
  | LazyTrigger<{ search: string; page: number }>
  | LazyTrigger<{ search: string; page: number; personId: number }>;

interface ISearchReferralMembersOptions {
  module?: PeakModules;
  memberId?: number;
  isCampaignForm?: boolean;
}

const useSearchReferralMembers = ({
  module,
  memberId,
  isCampaignForm,
}: ISearchReferralMembersOptions): SearchReferralMembersReturn => {
  const [getReferralMember] = useLazyGetReferralMembers();
  const [getFrontDeskReferralMembers] = useLazyGetFrontDeskReferralMembers();
  const [getReferralLeads] = useLazyGetReferralLeads();
  const [getPersonReferralMembers] = useLazyGetPersonReferralMembers();
  const [getReferralPTLeads] = useLazyGetReferralPTLeads();
  const [getCampaignReferralMembers] = useLazyGetCampaignReferralMembers();
  const [getPTCampaignReferralMembers] = useLazyGetPTCampaignReferralMembers();

  switch (module) {
    case PeakModules.Crm:
      return isCampaignForm ? getCampaignReferralMembers : getReferralLeads;
    case PeakModules.Members:
      return getReferralMember;
    case PeakModules.PersonalTrainingCrm:
      return isCampaignForm ? getPTCampaignReferralMembers : getReferralPTLeads;
    default:
      if (memberId) {
        return getPersonReferralMembers;
      } else {
        return getFrontDeskReferralMembers;
      }
  }
};

export default useSearchReferralMembers;
